export class GenProfileModuleEntity{
    id:number;
    profileId:number;
    moduleId:number;

    constructor(){}
}